import { isError } from 'es-toolkit/predicate';

export const castError = (error: unknown): Error | undefined => {
  if (isError(error) || typeof error === 'undefined') return error;
  if (typeof error === 'string') return new Error(error);
  if (typeof error === 'number') return new Error(error + '');

  return new Error('An unknown error occurred');
};
